import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/index'
import store from '@/store/index'
import filters from '@/filters/index'

import database from '@/db/database'

import '@/plugins'

Vue.config.productionTip = false

Vue.use(database)
Vue.use(filters)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
